import { getVoucherByCode } from "@/services/customer";
import { Internal_Token } from "@/services/auth";
import { encrypt } from "@/utils/encodingdecoding";
import { saveToken } from "@/utils/tokenHelper";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const savedCode = localStorage.getItem("qrCode");

const tokenBody = {
  clientid: encrypt(process.env.REACT_APP_CLIENT_ID),
  grant_type: "client_credentials",
  clientsecret: encrypt(process.env.REACT_APP_SECRET_KEY),
};

export const fetchVoucherByCode = createAsyncThunk(
  "qr/fetchVoucherByCode",
  async ({ token, code }, { rejectWithValue }) => {
    try {
      const res = await getVoucherByCode(token, code);
      return res;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

// ── Login page pe QR ko independently validate karne ke liye
// (khud ka token generate karta hai, kyunki login se pehle koi token nahi hota)
export const validateQrCode = createAsyncThunk(
  "qr/validateQrCode",
  async (code, { rejectWithValue }) => {
    try {
      const tokenRes = await Internal_Token(tokenBody);
      if (!tokenRes?.access_token) {
        return rejectWithValue("Token not generated");
      }

      const res = await getVoucherByCode(tokenRes.access_token, code);
      const data = res?.data?.voucher;

      if (!data) return { valid: false, reason: "invalid" };
      if (data.voucherUsed === true) return { valid: false, reason: "used" };
      if (data.isAssigned === true) return { valid: false, reason: "assigned" };
      if (new Date(data.expiryDate) < new Date()) {
        return { valid: false, reason: "expired" };
      }

      return { valid: true, reason: null, voucher: data };
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const qrSlice = createSlice({
  name: "qr",
  initialState: {
    code: savedCode || null,
    voucher: null,
    loading: false,
    error: null,
    // ── naya validation state (login page ke liye)
    validation: {
      status: "idle", // idle | loading | done
      valid: null,
      reason: null,
    },
  },
  reducers: {
    setQrCode: (state, action) => {
      state.code = action.payload;
      state.voucher = null;
      state.error = null;
      state.validation = { status: "idle", valid: null, reason: null };

      if (action.payload) {
        localStorage.setItem("qrCode", action.payload);
      } else {
        localStorage.removeItem("qrCode");
      }
    },
    clearQrCode: (state) => {
      state.code = null;
      state.voucher = null;
      state.error = null;
      state.validation = { status: "idle", valid: null, reason: null };
      localStorage.removeItem("qrCode");
    },
    clearVoucher: (state) => {
      state.voucher = null;
      state.error = null;
    },
    resetQrValidation: (state) => {
      state.validation = { status: "idle", valid: null, reason: null };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchVoucherByCode.pending, (state) => {
        state.loading = true;
        state.voucher = null;
        state.error = null;
      })
      .addCase(fetchVoucherByCode.fulfilled, (state, action) => {
        state.loading = false;
        state.voucher = action.payload;
      })
      .addCase(fetchVoucherByCode.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(validateQrCode.pending, (state) => {
        state.validation = { status: "loading", valid: null, reason: null };
      })
      .addCase(validateQrCode.fulfilled, (state, action) => {
        state.validation = {
          status: "done",
          valid: action.payload.valid,
          reason: action.payload.reason,
        };
      })
      .addCase(validateQrCode.rejected, (state) => {
        // API hi fail ho gayi — is case me QR ko block nahi karenge,
        // signup-time check dubara verify kar lega
        state.validation = { status: "done", valid: null, reason: null };
      });
  },
});

export const { setQrCode, clearQrCode, clearVoucher, resetQrValidation } = qrSlice.actions;
export default qrSlice.reducer;